"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.singleton = exports.toArray = void 0;
const toArray = (arr) => {
    return [arr.head, ...arr.tail];
};
exports.toArray = toArray;
const singleton = (value) => {
    return { head: value, tail: [] };
};
exports.singleton = singleton;
//# sourceMappingURL=NonEmptyArray.js.map